async function updateDiscountMessage() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    async function getRelevantCount(cart) {
      let count = 0;

      for (const item of cart.items) {
        try {
          const response = await fetch(`/products/${item.handle}.js`);
          const product = await response.json();

          if (product.tags.includes('rabatt-ausschluss')) {
            continue;
          }

          count += item.quantity;
        } catch (e) {
          console.error(e);
          count += item.quantity;
        }
      }

      return count;
    }

    const relevantCount = await getRelevantCount(cart);

    const containerId = "dynamic-discount-message";
    let messageElement = document.getElementById(containerId);

    if (!messageElement) {
      const cartFooter = document.querySelector('[data-cart-footer], .cart__footer, form[action="/cart"]');

      if (cartFooter) {
        messageElement = document.createElement("div");
        messageElement.id = containerId;
        messageElement.style.marginTop = "1rem";
        messageElement.style.fontWeight = "600";
        messageElement.style.textAlign = "center";
        cartFooter.insertAdjacentElement("beforebegin", messageElement);
      }
    }

    if (!messageElement) return;

    if (relevantCount === 0) {
      messageElement.textContent = "";
      return;
    }

    const discountLevels =
      window.discountMessageConfig &&
      Array.isArray(window.discountMessageConfig.discountLevels)
        ? window.discountMessageConfig.discountLevels
        : [
            { qty: 5, discount: 10 },
            { qty: 10, discount: 15 },
            { qty: 25, discount: 20 },
            { qty: 50, discount: 25 }
          ];

    const sortedLevels = [...discountLevels].sort((a, b) => a.qty - b.qty);
    const nextLevel = sortedLevels.find(level => relevantCount < level.qty);

    if (nextLevel) {
      const diff = nextLevel.qty - relevantCount;
      messageElement.textContent = `Legen Sie noch ${diff} Artikel in den Warenkorb und erhalten Sie ${nextLevel.discount}% Rabatt!`;
    } else {
      const maxDiscount = sortedLevels[sortedLevels.length - 1].discount;
      messageElement.textContent = `Sie haben bereits ${maxDiscount}% Rabatt erreicht! 🎉`;
    }
  } catch (error) {
    console.error('Fehler beim Laden des dynamischen Rabatthinweises:', error);
  }
}

document.addEventListener("DOMContentLoaded", updateDiscountMessage);

document.addEventListener("shopify:section:load", (event) => {
  if (event.detail && event.detail.sectionId && event.detail.sectionId.includes("cart")) {
    updateDiscountMessage();
  }
});

document.addEventListener("cart:updated", updateDiscountMessage);
document.addEventListener("cart:change", updateDiscountMessage);

setInterval(updateDiscountMessage, 5000);